<script setup lang="ts">
import { getAlmInfo } from "@/backend/read/BackendReader";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { moreMenuKey } from "@/components/menu/ActionMenu/injectKeys";
import MenuListItem from "@/components/ui/MenuList/MenuListItem.vue";
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);
const more = injectStrict(moreMenuKey);
const almInfo = getAlmInfo();
</script>

<template>
  <MenuListItem
    v-if="card.almId"
    as="a"
    class="alm-menu-item"
    :href="card.almIssueUrl"
    target="_blank"
    :icon="almInfo.icon"
    :text="$t('cardAction.openInAlm', { almName: almInfo.name })"
    :tooltip="card.almId"
    :aria-label="$t('label.actionMenu.almIssue')"
    @click="more.close()"
    @pointerenter="more.hover($event, null)"
  >
    <template #after>
      <SvgIcon name="general/external-link" width="20" height="20" />
    </template>
  </MenuListItem>
</template>

<style lang="scss" scoped>
.alm-menu-item {
  text-decoration: none;
}
</style>
